// extracted by mini-css-extract-plugin
export default {"short-address":"ShortAddress_short-address__qGy5F"};